"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const layout_1 = require("@chakra-ui/layout");
exports.default = layout_1.Box;
